import { Controller } from "@hotwired/stimulus"
import * as bootstrap from 'bootstrap'

export default class extends Controller {
  static targets = ["modal", "submitButton"]

  connect() {
    // Listen for form submit
    this.element.addEventListener("submit", this.showModal.bind(this))
  }

  showModal(event) {
    // Check if form is valid (HTML5 validation)
    if (!this.element.checkValidity()) {
      return
    }

    // Check for client-side validation errors (client_side_validations gem)
    const hasErrors = this.element.querySelectorAll('.field_with_errors, .error').length > 0
    if (hasErrors) {
      return
    }

    // Disable the submit button to prevent double submissions
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add("disabled")
    }

    // Show the modal
    if (this.hasModalTarget) {
      const modal = new bootstrap.Modal(this.modalTarget, {
        backdrop: 'static',  // Prevent closing by clicking outside
        keyboard: false      // Prevent closing with ESC key
      })
      modal.show()
    }
  }
}
